// extracted by mini-css-extract-plugin
export default {"section":"Intro_section__JNr5k","wrap":"Intro_wrap__G4fyK","title":"Intro_title__6TN2-","text":"Intro_text__YQhw2","gallery":"Intro_gallery__GR95l","preview":"Intro_preview__cVb-f"};